import {
  ResignationSchema,
  ResignationArraySchema,
} from "../schema";
import { normalize } from "normalizr";
import { message } from "antd";

import {
  createListAction,
  createDetailAction,
  createNewEntityAction,
  createArchiveAction,
  createDeleteAction,
  createUnarchiveAction,
  createEntityActionAction,
} from "@modules/utils/action-creator";
import { setRequestInProcess } from "@/actions/request";
import { mergeEntities } from "@/actions/entity";
import { setError } from "@/actions/error";
import * as service from "../services";
import * as ResignationConstants from "../constants";

const path = ResignationConstants.STAFF_TURNOVER_MODULE_PATH;

export const getAll = (values) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.getResignationList,
    schema: ResignationArraySchema,
    requestName: ResignationConstants.RESIGNATION_LIST_REQUEST,
    dispatch,
    getState,
  };
  return createListAction(options, values);
};

export const createResignation = (values) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.createResignation,
    requestName: ResignationConstants.RESIGNATION_CREATE_REQUEST,
    dispatch,
    getState,
    redirectUrl: path,
    entityName: ResignationConstants.STAFF_TURNOVER_MODULE_TITLE,
    successMessage: "Staff turnover draft saved successfully",
    schema: ResignationSchema,
  };
  return createNewEntityAction(options, values);
};

export const getResignationDetail = (id) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.getResignationDetail,
    requestName: ResignationConstants.RESIGNATION_DETAIL_REQUEST,
    dispatch,
    getState,
    schema: ResignationSchema,
  };
  return createDetailAction(options, id);
};

export const archiveResignation = (id, noRedirect) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.archiveResignation,
    requestName: ResignationConstants.RESIGNATION_ARCHIVE_REQUEST,
    dispatch,
    getState,
    redirectUrl: noRedirect ? false : path,
    successMessage: "Staff turnover archived successfully!",
  };
  return createArchiveAction(options, id);
};

export const deleteResignation = (id) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.deleteResignation,
    requestName: ResignationConstants.RESIGNATION_DELETE_REQUEST,
    dispatch,
    getState,
    redirectUrl: path,
    successMessage: "Staff turnover deleted successfully!",
  };
  return createDeleteAction(options, id);
};

export const unarchiveResignation = (id) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.unarchiveResignation,
    requestName: ResignationConstants.RESIGNATION_UNARCHIVE_REQUEST,
    dispatch,
    getState,
    successMessage: "Staff turnover unarchived successfully!",
  };
  return createUnarchiveAction(options, id);
};

export const submitResignation = (id) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.submitResignation,
    schema: ResignationSchema,
    requestName: ResignationConstants.RESIGNATION_SUBMIT_REQUEST,
    dispatch,
    getState,
    successMessage: "Staff turnover request submitted successfully",
  };
  return createEntityActionAction(options, id);
};

export const approveResignation = (id, successMessage) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.approveResignation,
    schema: ResignationSchema,
    requestName: ResignationConstants.RESIGNATION_APPROVE_REQUEST,
    dispatch,
    getState,
    successMessage: successMessage || "Staff turnover approved successfully!",
  };
  return createEntityActionAction(options, id);
};

export const rejectResignation = (id) => (dispatch, getState) => {
  const options = {
    serviceMethod: service.rejectResignation,
    schema: ResignationSchema,
    requestName: ResignationConstants.RESIGNATION_REJECT_REQUEST,
    dispatch,
    getState,
    successMessage: "Staff turnover rejected successfully!",
  };
  return createEntityActionAction(options, id);
};

export const processResignation = ({ id, terminationDate }) => (dispatch, getState) => {
  const requestName = ResignationConstants.RESIGNATION_PROCESS_REQUEST;
  const requestInProcess = getState().request[requestName];

  if (requestInProcess) {
    return Promise.resolve();
  }

  dispatch(setRequestInProcess(true, requestName));
  return service.processResignation(id, { terminationDate })
    .then((response) => {
      const normalized = normalize(response, ResignationSchema);
      dispatch(mergeEntities(normalized.entities));
      dispatch(setRequestInProcess(false, requestName));
      message.success("Staff turnover processed successfully.");
      return response;
    })
    .catch((error) => {
      dispatch(setRequestInProcess(false, requestName));
      dispatch(setError(error, requestName));
      return Promise.reject(error);
    });
};
